export const applicationStagesSettingController = (
  $scope,
  $uibModal,
  $location,
  logger,
  ApplicationStagesApi,
  $timeout
) => {
  var modalInstance

  $scope.openStageSettingModal = () => {
    $scope.applicationStagesList = angular.copy(
      $scope.hierarchialApplicationStages
    )
    modalInstance = $uibModal.open({
      animation: true,
      templateUrl: 'application-stages-setting-modal.html',
      windowClass: 'app-modal-window',
      backdrop: 'static',
      scope: $scope,
    })

    return modalInstance.result
  }

  $scope.expandStage = stage => {
    stage.expand = !stage.expand
  }

  $scope.onEditClick = stage => {
    $scope.inputField = true
    stage.temporaryName = stage.name
    stage.temporaryIsDefault = stage.isDefault
    stage.temporaryColor = stage.color
    stage.isEditable = true
  }

  $scope.onInputFieldCloseClick = stage => {
    stage.newStage = false
    stage.isEditable = false
    $scope.inputField = false
  }

  function makeDefault(selectedStage) {
    if (selectedStage.isDefault) {
      $scope.applicationStagesList.forEach(stage => {
        if (stage.children) {
          if (stage.children.length > 0) {
            stage.children.forEach(subStage => {
              if (subStage.id !== selectedStage.id) subStage.isDefault = false
            })
          }
        }
      })
    } else {
      const isDefault = $scope.applicationStagesList.find(x =>
        x.children.find(child => child.isDefault === true)
      )
      if (!isDefault || !(isDefault.children.length > 0))
        $scope.applicationStagesList[0].children[0].isDefault = true
    }
  }

  function errorHandler(status) {
    const USER_NOT_LOGGED_IN = 440
    const INTERNAL_SERVER_ERROR = 500

    if (Number(status) === USER_NOT_LOGGED_IN) $location.url('/signin')
    if (Number(status) === INTERNAL_SERVER_ERROR)
      logger.notify(
        'error',
        "Can't Delete Stage. Application Records exist in it!"
      )
    else logger.notify('error', 'update Failed!')
  }

  $scope.updateStage = async stage => {
    $scope.inputField = false
    if (stage.temporaryName === '' || stage.temporaryName === null) {
      logger.notify('warning', 'Stage Name is empty')
    } else {
      let ifExist = nameAlreadyExist(stage.temporaryName, stage.id)
      if (ifExist > 0) {
        logger.notify('warning', 'Name is Already Used')
      } else {
        const payload = {
          name: stage.temporaryName,
          color: stage.temporaryColor ? stage.temporaryColor : '#5e5e5e',
          isDefault: stage.temporaryIsDefault,
        }
        const {status} = await ApplicationStagesApi.updateApplicationStage(
          stage.id,
          payload
        )
        if (status === 200) {
          stage.isEditable = false
          stage.name = stage.temporaryName
          stage.isDefault = stage.temporaryIsDefault
          stage.color = stage.temporaryColor
          makeDefault(stage)
          angular.copy(
            $scope.applicationStagesList,
            $scope.hierarchialApplicationStages
          )
          updateLinearApplication($scope.applicationStagesList, stage)
          logger.notify('success', 'Stage Updated')
          $scope.$apply()
        } else errorHandler(status)
      }
    }
  }

  $scope.deleteStage = (name, stage, list, index, event) => {
    if (name === 'parent') {
      if (stage.children === undefined) {
        deleteModal(event, stage, list, index)
      } else if (stage.children.length > 0) {
        logger.notify('warning', "Can't Delete Stage. Sub-stages exist in it.")
      } else {
        deleteModal(event, stage, list, index)
      }
    } else if (stage.isDefault === true)
      logger.notify('warning', "Can't Delete Default Sub-stage.")
    else deleteModal(event, stage, list, index)
  }

  let deleteModalInstance
  $scope.cancelDelete = () => {
    deleteModalInstance.dismiss('cancel')
  }

  $scope.confirmDelete = () => deleteModalInstance.close()
  function deleteModal(event, stage, list, index) {
    event.stopPropagation()
    deleteModalInstance = $uibModal.open({
      templateUrl: 'deleteStageModal.html',
      scope: $scope,
    })
    deleteModalInstance.result.then(
      async () => {
        try {
          const {status} = await ApplicationStagesApi.deleteApplicationStage(
            stage.id
          )
          if (status === 200) {
            logger.notify('success', 'Stage Deleted')
            list.splice(index, 1)
            angular.copy(
              $scope.applicationStagesList,
              $scope.hierarchialApplicationStages
            )
            updateLinearApplication($scope.applicationStagesList)
          } else errorHandler(status)
        } catch (error) {
          errorHandler(error.status)
        }
      },
      () => {}
    )
  }

  $scope.parentStage = {}
  $scope.insertParentStage = async stage => {
    const parentStage = $scope.parentStage
    if (
      parentStage.name === '' ||
      parentStage.name === null ||
      parentStage.name === undefined
    ) {
      logger.notify('warning', 'Stage Name is empty')
    } else {
      const isNameExist = nameAlreadyExist(parentStage.name)
      if (isNameExist > 0) {
        logger.notify('warning', 'Name is Already Used')
      } else {
        $scope.inputField = false
        stage.newStage = false
        const payload = {
          name: parentStage.name ? parentStage.name : '',
          color: parentStage.color ? parentStage.color : '#5e5e5e',
          isDefault: parentStage.isDefault ? 1 : 0,
          order: $scope.applicationStagesList.length + 1,
        }

        const {
          data,
          status,
        } = await ApplicationStagesApi.createApplicationStage(payload)
        if (status === 201) {
          logger.notify('success', 'New Stage Added')

          data.children = []
          $scope.hierarchialApplicationStages.push(data)
          $scope.parentStage = {}
          $scope.applicationStagesList = angular.copy(
            $scope.hierarchialApplicationStages
          )
          updateLinearApplication($scope.applicationStagesList, false)
          angular.copy(
            $scope.applicationStagesList,
            $scope.hierarchialApplicationStages
          )
          $scope.$apply()
        } else errorHandler(status)
      }
    }
  }

  function nameAlreadyExist(name, id) {
    let existingName = 0
    $scope.applicationStagesList.forEach(stage => {
      if (
        stage.id !== id &&
        stage.name.toLowerCase().localeCompare(name.toLowerCase()) === 0
      ) {
        existingName = 2
        return existingName
      }

      if (stage.children) {
        if (stage.children.length > 0) {
          stage.children.forEach(subStage => {
            if (
              subStage.id !== id &&
              subStage.name.toLowerCase().localeCompare(name.toLowerCase()) ===
                0
            ) {
              existingName++
            }
          })
        }
      }
    })
    return existingName
  }

  $scope.insertSubStage = async (state, stage) => {
    if (state.name === '' || state.name === null || state.name === undefined) {
      logger.notify('warning', 'Stage Name is empty')
    } else {
      const isNameExist = nameAlreadyExist(state.name, state.id)
      if (isNameExist > 0) {
        logger.notify('warning', 'Name is Already Used')
      } else {
        $scope.inputField = false

        const payload = {
          name: state.name,
          color: state.color ? state.color : '#5e5e5e',
          parentId: stage.id,
          isDefault: state.isDefault ? 1 : 0,
          order: stage.children.length,
        }

        const {
          data,
          status,
        } = await ApplicationStagesApi.createApplicationStage(payload)
        if (status === 201) {
          logger.notify('success', 'New Sub-Stage Added')
          stage.newSubStage = false
          stage.children.pop()
          data.displayIcon = false
          makeDefault(data)
          stage.children.push(data)
          updateLinearApplication($scope.applicationStagesList)
          angular.copy(
            $scope.applicationStagesList,
            $scope.hierarchialApplicationStages
          )
          $scope.$apply()
        }
      }
    }
  }

  function updateLinearApplication(applicationStagesList, updateStageOnGrid) {
    let listAllStages = []
    applicationStagesList.forEach(stage => {
      listAllStages = [...listAllStages, stage]
      if (stage.children) {
        if (stage.children.length > 0) {
          stage.children.forEach(subStage => {
            subStage.isHidden = true
            subStage.parentName = stage.name
            subStage.parentId = stage.id
            listAllStages.push(subStage)
          })
        }
      }
    })
    $scope.successCallBack({list: applicationStagesList, updateStageOnGrid})

    $scope.allApplicationStages.length = 0
    ;[].push.apply($scope.allApplicationStages, listAllStages)
  }

  $scope.inputField = false
  $scope.updateStagesOrder = async stage => {
    if ($scope.inputField) {
      logger.notify('warning', ' Please Complete and Save the Changes')
    } else {
      const payload = []
      stage.forEach((parent, stageIndex) => {
        payload.push({
          id: parent.id,
          order: stageIndex + 1,
          parentId: undefined,
        })
        parent.children.forEach((child, subStageIndex) => {
          if (child.id !== undefined) {
            payload.push({
              id: child.id,
              order: subStageIndex + 1,
              parentId: parent.id,
            })
          }
        })
      })
      const {
        data,
        status,
      } = await ApplicationStagesApi.updateApplicationStageOrder(payload)
      if (status === 200) {
        logger.notify('success', data)
        const {
          data: stages,
        } = await ApplicationStagesApi.getAllApplicationStages({
          hierarchy: true,
        })
        angular.copy($scope.applicationStagesList, stages)
        updateLinearApplication($scope.applicationStagesList)
        modalInstance.dismiss('cancel')
      } else errorHandler(status)
    }
  }

  $scope.addNewSubStage = stage => {
    const index = {}
    $scope.inputField = true
    if (stage.children === undefined) {
      stage.children = []
      stage.children.push(index)
      stage.newSubStage = true
    } else {
      stage.children.push(index)
      stage.newSubStage = true
    }
  }

  $scope.addStageShow = parentStage => {
    parentStage.newStage = true
    $scope.inputField = true
    $timeout(() => {
      // eslint-disable-next-line angular/document-service
      document.querySelector('#input-newParentStage').focus()
    }, 50)
  }

  $scope.closeSubStage = stage => {
    $scope.inputField = false
    stage.children.pop()
    stage.newSubStage = false
  }

  $scope.cancelModal = () => {
    modalInstance.dismiss('cancel')
  }

  $scope.colorChildren = color => {
    if (color) {
      var faddedColor = hexToRGB(color, 0.1)
      return {
        background: faddedColor,
        border: '1px solid ' + color,
      }
    }
  }
}

function hexToRGB(h, opacity) {
  let r = 0
  let g = 0
  let b = 0

  // 3 digits
  if (h.length === 4) {
    r = '0x' + h[1] + h[1]
    g = '0x' + h[2] + h[2]
    b = '0x' + h[3] + h[3]

    // 6 digits
  } else if (h.length === 7) {
    r = '0x' + h[1] + h[2]
    g = '0x' + h[3] + h[4]
    b = '0x' + h[5] + h[6]
  }

  return (
    'rgba(' +
    Number(r) +
    ',' +
    Number(g) +
    ',' +
    Number(b) +
    ', ' +
    opacity +
    ')'
  )
}



// WEBPACK FOOTER //
// ./scripts/shared/directives/application/application-stages-setting/application-stages-setting.ctrl.js